import React from 'react';
import { DOCUMENT_CATALOG, DOCUMENT_GROUPS, DOCUMENT_STATE_LABELS } from '../utils/documentCatalog.js';
import './DocumentCatalog.css';

export default function DocumentCatalog({ onSelectTemplate, onOpenRecords }) {
    return <section className="document-catalog" aria-labelledby="document-catalog-title" data-testid="document-catalog">
        <h2 id="document-catalog-title">دليل مستندات الورشة</h2>
        <p className="document-catalog-note">هذا دليل للمسميات وحالة نماذج الطباعة، وليس شاشة إصدار أو سداد. توفر قالب لا يعني اكتمال دورة المستند. الكشوف تقرأ البيانات ولا تنشئ حركة مالية.</p>
        <div className="document-catalog-groups">
            {DOCUMENT_GROUPS.map((group) => <section key={group.id} aria-labelledby={`document-group-${group.id}`}>
                <h3 id={`document-group-${group.id}`}>{group.title}</h3>
                <ul>
                    {DOCUMENT_CATALOG.filter((doc) => doc.group === group.id).map((doc) => <li key={doc.id} data-testid={`document-kind-${doc.id}`}>
                        <div className="document-catalog-heading"><h4>{doc.title}</h4><span className={`document-state ${doc.state}`}>{DOCUMENT_STATE_LABELS[doc.state]}</span></div>
                        <p>{doc.description}</p>
                        {doc.state === 'record' && <button type="button" className="tm-button" onClick={onOpenRecords}>فتح سجل المستندات</button>}
                        {doc.templateType
                            ? <button type="button" className="tm-button" onClick={() => onSelectTemplate(doc.templateType)} aria-label={`إدارة قالب ${doc.title}`}>إدارة القالب</button>
                            : doc.state !== 'record' && <span className="document-catalog-unavailable">لا يمكن إصدار هذا النموذج من القسم حاليًا.</span>}
                    </li>)}
                </ul>
            </section>)}
        </div>
    </section>;
}
